import { QueryValues } from '@/types/algonomy';
import AlgonomyFrontend from '../AlgonomyFrontend';
import { SearchParams } from '../../service';
import { CategoriesFrontendService } from './service';

class CategoriesFrontend extends AlgonomyFrontend implements CategoriesFrontendService {
  /**
   * filter query params in order to not get to algonomy query string
   */
  public getFilterValues(queryObject: QueryValues | SearchParams): QueryValues {
    // TODO: maybe we don't need this method
    const { categorySlug, ...rest } = super.getFilterValues(queryObject);

    return rest;
  }
}

export default CategoriesFrontend;
